<app-menu></app-menu>

<div class="main-admin-menu" *ngIf="GetActiveUser()">
    <div class="admin-menu">
        <h5>Witaj!&nbsp;<strong>{{displayName()}}</strong></h5>
        <button type="button" class="btn btn-info" (click)="navigateToLogout()">Wyloguj</button>
    </div>
</div>

<div class="main">
    <div class="card main-card" *ngFor="let info of infos">
        <div class="card-body">
            <div [innerHTML]="info.text | safeHtml" class="card-text"></div>
            <button type="button" class="btn btn-warning" (click)="openModalEdit(info)" *ngIf="GetActiveUser()">Edytuj</button>
        </div>
    </div>
</div>